import React from 'react';
import C from '../../colors';

const PaymentDialog = ({ paymentQrCode, open, onClose, onPaymentCompleted }) => {
  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(26,20,23,.55)', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 16, border: `1px solid ${C.hair}`, width: '100%', maxWidth: 360, boxShadow: '0 24px 60px -12px rgba(0,0,0,.25)', padding: '28px 28px 24px', textAlign: 'center' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', cursor: 'pointer', color: C.ink3, display: 'grid', placeItems: 'center' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
        <h3 style={{ margin: '0 0 8px', fontFamily: C.serif, fontSize: 22, fontWeight: 400, color: C.ink }}>支付</h3>
        <p style={{ margin: '0 0 20px', fontSize: 13, color: C.ink3 }}>请扫描二维码完成支付</p>
        {paymentQrCode && (
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
            <img src={`data:image/png;base64,${paymentQrCode}`} alt="Payment QR Code" style={{ width: 200, height: 200, border: `1px solid ${C.hair}`, borderRadius: 8, padding: 8 }}/>
          </div>
        )}
        <button onClick={() => onPaymentCompleted?.()} style={{ width: '100%', padding: '11px 0', borderRadius: 10, border: 'none', background: C.brand, color: '#fff', fontFamily: C.sans, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
          支付完成
        </button>
      </div>
    </div>
  );
};
export default PaymentDialog;
